import { Card, Box } from '@chakra-ui/react'
import ModuleBrand from './components/ModuleBrand'
import { usePatchNotes } from '../../../../contexts/PatchNotes/Provider'

interface ModuleContainerProps {
  children: JSX.Element
  moduleName:
    | 'ACTIVITIES'
    | 'APP_CITIZEN'
    | 'ASSESSMENTS_AND_RESEARCH'
    | 'ATTENDANCES'
    | 'CITIZEN_PORTAL'
    | 'CITIZEN_PROFILE'
    | 'DATA_INTEGRATOR'
    | 'DIGITAL_ARCHIVE'
    | 'GEO'
    | 'INSTITUTIONAL_MANAGEMENT'
    | 'INVENTORY'
    | 'MESSENGER'
    | 'OBSERVATORY'
    | 'PROCESSES_AND_DOCUMENTS'
    | 'REGULATION'
    | 'SCHEDULES'
    | 'SERVICES_LETTER'
    | 'UNIFIED_LOGIN'
    | 'VULNERABILITY_ALERTS'
    | 'GENERAL'
}

export default function ModuleContainer({ children, moduleName }: ModuleContainerProps) {
  const { modulesFilters } = usePatchNotes()
  return (
    <Card
      border="1px solid"
      borderColor="borderColor"
      rounded="md"
      bg="bgContent"
      p={2}
      gap={2}
      w="full"
      display={modulesFilters[moduleName] ? 'block' : 'none'}
    >
      <ModuleBrand module={moduleName} />
      <Box w="full">{children}</Box>
    </Card>
  )
}
